module.exports = __webpack_public_path__ + "media/images/logo_small-8e8b3280bbc81f1548b8313cbfb1382e.png";